var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFBF00",
    clipPath: "url(#token-gg_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fillOpacity: 0.1,
    rx: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5.614c2.015 0 3.78 2.816 4.764 5.666L14 14.03l-4.765-2.752c.984-2.85 2.75-5.664 4.765-5.664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.164 12.58.141.216a6.08 6.08 0 0 1-.854 7.686A6.35 6.35 0 0 1 14 22.289z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.002 15.53 5.166-2.95-5.166 9.709z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.833 12.58-.141.216a6.08 6.08 0 0 0 .854 7.686 6.35 6.35 0 0 0 4.452 1.807z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.991 15.53-5.166-2.95 5.166 9.709z",
    opacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "token-gg_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#fff",
    rx: 14
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gg.483fbc9ed7dcce9cfedd2e56f4f4183c.svg";